import { FC } from "react";

interface SingleProjetHeaderProps {
  logo: string;
  title: string;
  subtitle: string;
}

const SingleProjetHeader: FC<SingleProjetHeaderProps> = ({ logo, title, subtitle }) => {
  return (
    <div className="flex items-center space-x-4 p-4">
      <div className="bg-gray-200 rounded-xl p-4">
        <img src={logo} alt="project logo" className="w-10 h-10" />
      </div>
      <div>
        <h1 className="font-semibold text-2xl text-rajapiNavyBlue">{title}</h1>
        <p className="text-sm text-gray-500">{subtitle}</p>
      </div>
    </div>
  );
};

export default SingleProjetHeader;


